import { Svg } from 'react-native-svg'

const IconBase = (props) => {
  return <Svg fill="none" {...props} />
}

export { IconBase }
